import { DatePicker } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import styled from 'styled-components'

export const ProfileWrapper = styled.div``

export const ProfileContent = styled.div`
  padding: 0 0 24px;
  max-width: 1080px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: end;
  gap: 8px;
  align-items: center;
`

export const DeleteButtonText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color4};
`

export const GeneralText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color3};
`

export const ChildrenContainer = styled.div`
  display: flex;
  flex-direction: column;
`

export const ExtraText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color5};
`

export const ExtraErrorText = styled(Text)`
  color: ${(props) => props.theme.color.status.danger};
`

export const SupDatePicker = styled(DatePicker)`
  .ant-picker-input > input {
    font-size: 16px;
  }
`

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
`
